export default __webpack_public_path__ + "static/lokalizacja-ff0009e902e2253b5ad7777e66e75397.webp";